import React, { ComponentPropsWithoutRef } from 'react';
import { Grid, Table } from '@rbx/ui';
import useMarkdownTableStyles from './MarkdownTable.styles';
import MarkdownProvider from './MarkdownProvider';

type MarkdownTableProps = ComponentPropsWithoutRef<typeof Table> & {
  tableStyle?: React.CSSProperties;
};

export default function MarkdownTable({ children, tableStyle, ...otherProps }: MarkdownTableProps) {
  const {
    classes: { outerContainer, image },
  } = useMarkdownTableStyles();

  return (
    <Grid container className={outerContainer}>
      <Table {...otherProps} style={tableStyle}>
        <MarkdownProvider classes={{ image }}>{children}</MarkdownProvider>
      </Table>
    </Grid>
  );
}
